export default import.meta.ROLLDOWN_FILE_URL_4_tY1g4S4ewTPtt3KIxpYg